export { default } from './TrendGraph';
